var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "roomCallVideo",
      staticClass: "grm-video-layer one-fourth",
      class: _vm.roomUserCountStyle,
      attrs: {
        "data-grm-comp": "RoomCallCamstudyVideo.p2p",
        "data-user-id": _vm.user.userId,
        "data-screen-share": _vm.user.screenShare,
      },
    },
    [
      _c("StopWatch", { attrs: { user: _vm.user } }),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isUserScreenBlock(_vm.user.userId),
            expression: "isUserScreenBlock(user.userId)",
          },
        ],
        staticClass: "screen-block",
        domProps: {
          innerHTML: _vm._s(_vm.$t("camstudy.videoStatus.blockScreen")),
        },
      }),
      _c(
        "div",
        {
          ref: "roomVideoWrapper",
          staticClass: "relative w-full aspect-square",
        },
        [
          _vm.canvas ? _c("div", { ref: "canvasLayer" }) : _vm._e(),
          !_vm.canvas && _vm.stream
            ? _c("RoomVideo", {
                ref: "video",
                staticClass: "grm-video",
                style: _vm.roomVideoStyle,
                attrs: {
                  muted: true,
                  videoOnly: _vm.videoOnly,
                  myVideo: _vm.isMe,
                  user: _vm.user,
                },
                on: {
                  resize: _vm.onRoomVideoResize,
                  playing: _vm.onRoomVideoResize,
                },
              })
            : _vm._e(),
          _c("CamstudyVideoControl", {
            attrs: { user: _vm.user, pin: _vm.pin },
          }),
        ],
        1
      ),
      !_vm.isScreenShare
        ? _c(
            "div",
            {
              staticClass: "v-bg",
              class: {
                "no-cam":
                  (!!_vm.roomUser &&
                    _vm.roomUser.roomUserRole.camera == false) ||
                  _vm.roomUser.cameraStatus != "on",
                "no-user": !_vm.roomUser,
              },
            },
            [
              !_vm.roomUser
                ? _c("img", {
                    staticClass: "pointer-events-none",
                    style: {
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    },
                    attrs: { src: _vm.getUserImage },
                  })
                : _vm._e(),
              (!!_vm.roomUser && _vm.roomUser.roomUserRole.camera == false) ||
              _vm.roomUser.cameraStatus != "on"
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/images/camstudy/ico_no_cam.svg"),
                      alt: "no_cam",
                    },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c("div", [
        _c("div", {
          staticClass: "control-event-area",
          on: { click: _vm.onOpenUserControl },
        }),
        _vm.isOpenUserControl
          ? _c(
              "div",
              {
                staticClass: "user-control",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onCloseUserControl.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "control-chat",
                  on: { click: _vm.onOpenWhisperChat },
                }),
                _c("div", {
                  staticClass: "control-pin",
                  class: { active: _vm.pin },
                  on: { click: _vm.onPinMode },
                }),
              ]
            )
          : _vm._e(),
      ]),
      !!_vm.roomUser
        ? [
            _c("div", {
              staticClass: "v-peakmeter",
              class: {
                active:
                  _vm.roomUser && _vm.roomUser.isSpeaking && !_vm.isScreenShare,
              },
            }),
            _c("div", { staticClass: "v-user-info-area" }, [
              _c(
                "div",
                { staticClass: "v-name-area" },
                [
                  _c(
                    "div",
                    { staticClass: "v-name-img" },
                    [
                      _c("UserProfileImage", {
                        staticClass: "profile-image",
                        attrs: { "user-id": _vm.roomUser.userId },
                      }),
                      _vm.hasEmceeRole(_vm.roomUser.userId)
                        ? _c("GrmIcon", {
                            class: _vm.hasSpeakerRole(_vm.roomUser.userId)
                              ? "room-speaker"
                              : "room-emcee",
                            attrs: { icon: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "v-name ep flex items-center justify-between",
                      class: { isMe: _vm.isMe },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: _vm.roomUser.nickname,
                              expression: "roomUser.nickname",
                              modifiers: { top: true },
                            },
                          ],
                          staticClass:
                            "room-user-nickname min-w-0 max-w-max flex-1 truncate",
                        },
                        [_vm._v(_vm._s(_vm.roomUser.nickname))]
                      ),
                      _vm.roomUserCount > 2
                        ? _c("div", {
                            staticClass: "video-more-control",
                            on: { click: _vm.onToggleVideoMoreControl },
                          })
                        : _vm._e(),
                      _vm.roomUserCount <= 2 && _vm.isMe
                        ? _c(
                            "div",
                            { staticClass: "video-flex-control-container" },
                            [
                              _c("div", {
                                staticClass:
                                  "video-flex-control-container-item",
                                class:
                                  _vm.me.cameraStatus === "on"
                                    ? "camera-on"
                                    : "camera-off",
                                on: { click: _vm.onToggleUserDeviceStatus },
                              }),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isMobile,
                                    expression: "isMobile",
                                  },
                                ],
                                staticClass:
                                  "video-flex-control-container-item camera-transition",
                                on: { click: _vm.toggleCamera },
                              }),
                              _c("div", {
                                staticClass:
                                  "video-flex-control-container-item study-certification",
                                on: { click: _vm.onOpenStudyTimeSaveModal },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm.roomUserCount <= 2 && !_vm.isMe
                        ? _c(
                            "div",
                            { staticClass: "video-flex-control-container" },
                            [
                              _c("div", {
                                staticClass:
                                  "video-flex-control-container-item chat",
                                on: { click: _vm.onOpenWhisperChat },
                              }),
                              _c("div", {
                                staticClass:
                                  "video-flex-control-container-item pin",
                                class: { active: _vm.pin },
                                on: { click: _vm.onPinMode },
                              }),
                              _c("div", {
                                staticClass:
                                  "video-flex-control-container-item block",
                                on: {
                                  click: function ($event) {
                                    _vm.blockUserScreen({
                                      userId: _vm.user.userId,
                                      block: !_vm.isUserScreenBlock(
                                        _vm.user.userId
                                      ),
                                    })
                                  },
                                },
                              }),
                              _vm.hasEmceeRole() &&
                              !_vm.hasSpeakerRole(_vm.roomUser.userId)
                                ? _c("div", {
                                    staticClass:
                                      "video-flex-control-container-item go-out",
                                    on: {
                                      click: () => {
                                        _vm.isOpenKickOrBanUser = true
                                        _vm.onCloseVideoMoreControl()
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm.isOpenVideoMoreControl && _vm.isMe
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.onCloseVideoMoreControl,
                                  expression: "onCloseVideoMoreControl",
                                },
                              ],
                              staticClass: "video-more-control-container",
                              class: { isMe: _vm.isMe },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "video-more-control-item",
                                  on: { click: _vm.onToggleUserDeviceStatus },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "video-more-control-icon camera",
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `camstudy.control.camera.${
                                            _vm.me.cameraStatus === "on"
                                              ? "off"
                                              : "on"
                                          }`
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isMobile,
                                      expression: "isMobile",
                                    },
                                  ],
                                  staticClass: "video-more-control-item",
                                  on: { click: _vm.toggleCamera },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "video-more-control-icon camera-transition",
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("camstudy.control.camera.rotate")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "video-more-control-item",
                                  on: { click: _vm.onOpenStudyTimeSaveModal },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "video-more-control-icon study-certification",
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "camstudy.stopwatch.setting.saveImage"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm.isOpenVideoMoreControl && !_vm.isMe
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.onCloseVideoMoreControl,
                                  expression: "onCloseVideoMoreControl",
                                },
                              ],
                              staticClass: "video-more-control-container",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "video-more-control-item",
                                  on: { click: _vm.onOpenWhisperChat },
                                },
                                [
                                  _c("div", {
                                    staticClass: "video-more-control-icon chat",
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("camstudy.chat.directMessage")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "video-more-control-item",
                                  on: { click: _vm.onPinMode },
                                },
                                [
                                  _c("div", {
                                    staticClass: "video-more-control-icon pin",
                                    class: { active: _vm.pin },
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pin
                                          ? _vm.$t("camstudy.participant.unPin")
                                          : _vm.$t("camstudy.participant.pin")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "video-more-control-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.blockUserScreen({
                                        userId: _vm.user.userId,
                                        block: !_vm.isUserScreenBlock(
                                          _vm.user.userId
                                        ),
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "video-more-control-icon block",
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isUserScreenBlock(_vm.user.userId)
                                            ? _vm.$t(
                                                "camstudy.participant.unblockScreen"
                                              )
                                            : _vm.$t(
                                                "camstudy.participant.blockScreen"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.hasEmceeRole() &&
                              !_vm.hasSpeakerRole(_vm.roomUser.userId)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "video-more-control-item",
                                      on: {
                                        click: () => {
                                          _vm.isOpenKickOrBanUser = true
                                          _vm.onCloseVideoMoreControl()
                                        },
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "video-more-control-icon go-out",
                                      }),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "camstudy.participant.kick"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm.isOpenKickOrBanUser
                    ? _c("KickOrBanUser", {
                        attrs: { user: _vm.user },
                        on: { close: () => (_vm.isOpenKickOrBanUser = false) },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "v-user-determination" }, [
                _vm._v(_vm._s(_vm.userMsg)),
              ]),
            ]),
            _c("RoomSticker", {
              staticClass: "absolute inset-0",
              attrs: { "sticker-id": _vm.roomUser.stickerId },
            }),
          ]
        : _vm._e(),
      _vm.user.screenShare
        ? _c("RoomCallScreenShare", { attrs: { userId: _vm.user.userId } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }